// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bf410508","453":"32401148","732":"0048ec78"}[chunkId] + ".chunk.js";
};